import { render, staticRenderFns } from "./liveLink.vue?vue&type=template&id=4bcfa620&scoped=true"
import script from "./liveLink.vue?vue&type=script&lang=js"
export * from "./liveLink.vue?vue&type=script&lang=js"
import style0 from "./liveLink.vue?vue&type=style&index=0&id=4bcfa620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcfa620",
  null
  
)

export default component.exports